<template>
  <div :data-testid="dataTestid" class="h-44 w-full">
    <VChart :data-testid="`${dataTestid}-chart`" :option="option" :theme="OMR_ECHARTS_THEME" autoresize class="h-full w-full" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { OMR_ECHARTS_THEME } from '@/composables/useOmrEchartsTheme'
import { VChart, type OmrEChartsOption } from '@/config/echarts'
import { makeCompact } from '@/helpers/chartFormat'

const props = withDefaults(
  defineProps<{
    categories: string[]
    values: number[]
    color: string
    locale: string
    dataTestid?: string
  }>(),
  { dataTestid: 'insights-bar-chart' },
)

const option = computed<OmrEChartsOption>(() => {
  const compact = makeCompact(props.locale)

  return {
    tooltip: { trigger: 'axis', valueFormatter: (value) => compact(Number(value)) },
    grid: { top: 32, left: 8, right: 16, bottom: 8, containLabel: true },
    xAxis: { type: 'category', data: props.categories },
    yAxis: {
      type: 'value',
      splitNumber: 2,
      splitLine: { show: false },
      axisLabel: { formatter: (value: number | string) => compact(Number(value)) },
    },
    series: [
      {
        type: 'bar',
        data: props.values,
        barWidth: '80%',
        itemStyle: { color: props.color, borderRadius: [3, 3, 0, 0] },
        label: {
          show: true,
          position: 'top',
          fontWeight: 'bold',
          formatter: (params) => compact(Number(params.value)),
        },
      },
    ],
  }
})
</script>
